import React, { useEffect } from 'react';
import { CSVLink } from 'react-csv';
import SampleDataGrid from '../components/SampleDataGrid';
import { useSampleData } from '../hooks/useSampleData';
import '../components/SensorContainer.css';

const SampleDataContainer = () => {
  const {
    sampleData,
    csvExportData,
    startDate,
    endDate,
    machine,
    loading,
    setStartDate,
    setEndDate,
    setMachine,
    loadData,
    exportFilteredData,
    csvLinkRef
  } = useSampleData();

  useEffect(() => {
    loadData();
  }, [loadData]);

  const now = new Date();
  const formattedDateTime = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}_${String(now.getHours()).padStart(2, '0')}${String(now.getMinutes()).padStart(2, '0')}${String(now.getSeconds()).padStart(2, '0')}`;

  const handleSearch = () => {
    loadData();
  };

  return (
    <div className="container">
      {/* 필터 */}
      <div className="filterContainer">
        <label className="filterLabel">
          시작날짜:
          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            className="filterInput"
          />
        </label>
        <label className="filterLabel">
          종료날짜:
          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            className="filterInput"
          />
        </label>
        <label className="filterLabel">
          머신 ID:
          <input
            type="text"
            value={machine}
            onChange={(e) => setMachine(e.target.value)}
            placeholder="예: M01"
            className="filterInput"
          />
        </label>
        <button
          onClick={handleSearch}
          disabled={loading}
          className={`button buttonPrimary ${loading ? 'buttonDisabled' : ''}`}
        >
          {loading ? '검색중...' : '5초 평균 검색'}
        </button>
        <CSVLink
          data={csvExportData}
          filename={`sample_data_${formattedDateTime}.csv`}
          className="hidden"
          ref={csvLinkRef}
        />
        <button
          onClick={exportFilteredData}
          disabled={loading}
          className={`button buttonPrimary ${loading ? 'buttonDisabled' : ''}`}
        >
          {loading ? '검색중...' : '조건으로 바로 CSV 내보내기'}
        </button>
      </div>

      {/* 데이터 요약 + CSV 버튼 라인 */}
      <div style={{ width: '90%', margin: '0 auto' }}>
        <div
          className="statusSummary"
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '15px',
          }}
        >
          <div>
            <span>전체: {sampleData.length}건 (5초 평균 데이터)</span>
          </div>

          <CSVLink
            data={sampleData}
            filename={`sample_data_${formattedDateTime}.csv`}
            className="button buttonSuccess"
          >
            그리드 CSV 내보내기
          </CSVLink>
        </div>
      </div>

      <div className="tableScrollWrapper">
        <SampleDataGrid data={sampleData} />
      </div>
    </div>
  );
};

export default SampleDataContainer;